export default __webpack_public_path__ + "img/newComers.4cd56a00.svg";